import { Component } from '@angular/core';

@Component({
  selector: 'app-private-layout',
  templateUrl: './private-layout.component.html',
  styleUrls: ['./private-layout.component.css']
})
export class PrivateLayoutComponent {}


// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/layouts/private-layout/private-layout.component.ts